<div class="tituloInt tituloVentas">{{ 'GESTIONAR_VENTAS' | translate }}</div>

<ticketing-buscador-albaran></ticketing-buscador-albaran>

<ng-container *ngIf="albaran$ | async as albaran; else cargando">
  <ng-container *ngIf="!albaran.noData; else noResults">
    <ticketing-detalle-box [albaran]="albaran"></ticketing-detalle-box>
    <ticketing-operaciones-venta
      [albaran]="albaran"
    ></ticketing-operaciones-venta>
  </ng-container>
</ng-container>

<ng-template #noResults>
  <div class="DetalleBox__noResultsMessage">
    {{ 'MENSAJE_NO_DATOS' | translate }}
  </div>
</ng-template>

<ng-template #cargando>
  <div class="DetalleBox__noResultsMessage">
    <div class="lds-ring">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</ng-template>
